import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation loginCheckAccess($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
    }
  }
`

export const OAUTH_LOGIN = gql`
  mutation oauthLogin($email: String!) {
    authenticationTypeEmail(email: $email, origin: "web") {
      url
    }
  }
`

export const OAUTH_LOGIN_GET_TOKEN = gql`
  mutation oauthLoginGetToken($code: String!, $provider: String!, $email: String!) {
    authenticationExternalLogin(code: $code, provider: $provider, email: $email, origin: "web") {
      token
    }
  }
`
